export default __webpack_public_path__ + "static/media/auth-backgroundx3.d00ac450.webp";